import { render } from "./ChartAnalyticsNumPractice.vue?vue&type=template&id=e44adcf8&scoped=true"
import script from "./ChartAnalyticsNumPractice.vue?vue&type=script&lang=js"
export * from "./ChartAnalyticsNumPractice.vue?vue&type=script&lang=js"

import "@/css/components/chart-analytics-num-practice.css?vue&type=style&index=0&id=e44adcf8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44adcf8"]])

export default __exports__